module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_highlight-soft_80_eeeeee_1x100.png";